<app-page-header
    title="Gestión de Usuarios"
    mobileTitle="Usuarios"
    icon="fas fa-users"
    [showBack]="appSettings.isMobile() && showUserDetail"
    [unifiedOnMobile]="appSettings.isMobile() && showUserDetail"
    (back)="closeUserDetail()">
    @if (appSettings.isMobile() && !showUserDetail && perm.canCurrent('canCreate')) {
        <button headerExtra type="button" class="btn btn-primary btn-xs" (click)="toggleNewUserModal()">
            <i class="fas fa-plus me-1"></i>Nuevo
        </button>
    }
</app-page-header>

@if (appSettings.isMobile() && showUserDetail && showEntityFormPanel) {
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm" (click)="saveRoleEntitiesFromPanel()">
        Guardar
    </button>
</app-mobile-footer>
} @else if (appSettings.isMobile() && showUserDetail && mode() !== formMode.VIEW) {
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="userForm.invalid"
        (click)="handleFormChange(userForm.value)">
        Guardar
    </button>
</app-mobile-footer>
}

<div class="row">
    @if (!(appSettings.isMobile() && showUserDetail)) {
    <div [class]="appSettings.isMobile() ? 'col-12 mobile-requests-container' : 'col-md-3'">
        <div class="users-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            @if (!appSettings.isMobile()) {
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h4 class="mb-3">Listado de Usuarios</h4>
                @if (perm.canCurrent('canCreate')) {
                <button class="btn btn-primary btn-sm" (click)="toggleNewUserModal()"><i class="fas fa-plus"></i> Nuevo
                    Usuario</button>
                }
            </div>
            }
            <app-users-list (selectEvent)="onUserSelected($event)">

            </app-users-list>
        </div>
    </div>
    }

    @if (!appSettings.isMobile() || showUserDetail) {
    <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-9'">
        @if(selectedUser && !selectedUser.isNew){
        <div class="panel p-3 mb-3">
            @if (!appSettings.isMobile()) {
            <h4 class="mb-3">Detalle de Usuario</h4>
            }
            <app-user-form [userForm]="userForm" [parties]="availableParties" [(mode)]="mode" (formChange)="handleFormChange($event)" [minDate]="minDateStr" [maxDate]="maxDateStr">

                @if(mode() !== formMode.VIEW && !appSettings.isMobile()){
                <div class="d-flex justify-content-end mt-1">
                    <button class="btn btn-primary btn-sm" (click)="userForm.valid && handleFormChange(userForm.value)">
                        <i class="fas fa-save"></i> Guardar
                    </button>
                    &nbsp;
                    <button class="btn btn-secondary btn-sm"
                        (click)="$event.stopPropagation(); mode.set(formMode.VIEW)">
                        <i class="fas fa-times"></i> Cancelar
                    </button>
                </div>
                }
            </app-user-form>
        </div>

        @if(!selectedUser.isNew && showEntitiesPanel()){
        <div class="panel p-3">
            @if (appSettings.isMobile() && showEntityFormPanel) {
            <h4 class="mb-2">Asignar entidades</h4>
            <p class="text-muted small mb-2">Se guardan para el rol seleccionado.</p>
            <app-user-entities-form #entitiesFormPanel
                [entitiesAll]="activeEntities()"
                [allowedEntities]="assignableEntities()"
                [currentEntitiesIds]="getCodes(entitiesForSelectedRole())">
            </app-user-entities-form>
            <div class="d-flex justify-content-end gap-2 mt-2">
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="closeEntityFormPanel()">
                    Cancelar
                </button>
            </div>
            } @else {
            <app-user-entities-list
                [entities]="entitiesForSelectedRole()"
                [canManage]="perm.canCurrent('canUpdate')"
                [hideEntities]="isEntitiesRoleUser()"
                [allowedEntities]="assignableEntities()"
                title="Entidades del rol"
                (onRemove)="removeRoleEntity($event)"
                (onAdd)="toggleEntityModal()">
                <div entitiesHeaderExtra class="d-flex gap-2 align-items-center flex-wrap">
                    <select class="form-select form-select-sm" style="min-width: 200px;"
                        [ngModel]="entitiesRoleSlug ?? entitiesRoleId"
                        (ngModelChange)="onEntitiesRoleChange($event)">
                        @for (r of selectedUserRoles(); track (r.slug ?? r.id)) {
                        <option [ngValue]="r.slug ?? r.name ?? r.id">{{ r.displayName || r.description || r.slug || r.name }}</option>
                        }
                    </select>
                </div>
            </app-user-entities-list>
            @if (isEntitiesRoleUser()) {
            <div class="alert alert-info mb-0 mt-2">
                <i class="fas fa-info-circle"></i> El rol <strong>Usuario</strong> no tiene entidades: el alcance es el socio vinculado.
            </div>
            } @else {
            <small class="text-muted d-block mt-2">
                Alcance solo en <code>user_role_entity</code> para el rol seleccionado (p. ej. Unión con varias entidades, campo/socio con una).
            </small>
            }
            }
        </div>
        } @else if (userForm.get('isMaster')?.value) {
        <div class="alert alert-info">
            <i class="fas fa-info-circle"></i> Este usuario tiene <strong>Acceso Maestro</strong> y puede ver todas las
            entidades.
        </div>
        }
        } @else if (!appSettings.isMobile()) {
        <div class="panel">
            <div class="panel-body d-flex flex-column align-items-center justify-content-center text-center p-5"
                style="min-height: 400px;">
                <div class="mb-3 p-4 rounded-circle bg-light d-inline-flex align-items-center justify-content-center"
                    style="width: 80px; height: 80px;">
                    <i class="fas fa-users text-info fa-2x"></i>
                </div>
                <h4 class="text-muted fw-bold mb-2">No hay selección</h4>
                <div class="text-muted small">Selecciona un usuario de la lista para ver sus detalles y permisos.
                </div>
            </div>
        </div>
        }
    </div>
    }
</div>

<!-- Modal para asociar entidades al rol -->

<ng-template #entityModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title fw-bold"><i class="fas fa-link me-2 text-primary"></i> Entidades del rol</h5>
        <button type="button" class="btn-close" (click)="close()"></button>
    </div>
    <div class="modal-body">
        <p class="text-muted small mb-2">Se guardan en <code>user_role_entity</code> para el rol seleccionado.</p>
        <app-user-entities-form #entitiesFormInModal [entitiesAll]="activeEntities()"
            [allowedEntities]="assignableEntities()"
            [currentEntitiesIds]="getCodes(entitiesForSelectedRole())"></app-user-entities-form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
        <button type="button" class="btn btn-primary"
            (click)="saveRoleEntitiesFromModal(entitiesFormInModal)">Guardar</button>
    </div>
</ng-template>



<ng-template #newUser let-modal>
    <div class="modal-header">
        <h5 class="modal-title fw-bold"><i class="fas fa-link me-2 text-primary"></i> Nuevo Usuario</h5>
        <button type="button" class="btn-close" (click)="close()"></button>
    </div>
    <div class="modal-body">
        <app-user-form #userFormInModal [userForm]="userForm" [parties]="availableParties" (formChange)="handleFormChange($event)" [(mode)]="mode" [minDate]="minDateStr" [maxDate]="maxDateStr"></app-user-form>
        @if (!isFormUserRoleOnly()) {
        <hr class="my-3">
        <app-user-entities-form #entitiesFormInModal [entitiesAll]="activeEntities()"
            [allowedEntities]="assignableEntities()" [currentEntitiesIds]="[]">
        </app-user-entities-form>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">Cancelar</button>
        <button type="button" class="btn btn-primary"
            (click)="saveWithEntities(userFormInModal, entitiesFormInModal)">Guardar</button>
    </div>
</ng-template>
